import moment from 'moment'
import { BET_STATUSES } from '../../constants'

const msInDay = 86400000
const msInTwoDays = 172800000
const msInWeek = 604800000
const msInMonth = 2592000000
const msInThreeMoth = 7776000000

const getRange = (deltaMs) => {
  const now = Date.now()

  return {
    from: now - deltaMs,
    to: now
  }
}

const getStrictDaysRange = (deltaMs) => {
  const { from, to } = getRange(deltaMs)

  return {
    from: moment(from).startOf('day').valueOf(),
    to: moment(to).endOf('day').valueOf()
  }
}

export const getDayRange = () => getRange(msInDay)
export const getTwoDayRange = () => getRange(msInTwoDays)

export const getWeekRange = () => getStrictDaysRange(msInWeek)
export const getMonthRange = () => getStrictDaysRange(msInMonth)
export const getThreeMonthRange = () => getStrictDaysRange(msInThreeMoth)

export const last24 = 'last_24_hours'
export const last48 = 'last_48_hours'
export const rangeName = 'from'

export const dateRangeOptions = [
  last24,
  last48,
  rangeName
]
// special bet status to show bets which are available for cashout
export const BET_STATUS_TO_SELL = 'BET_STATUS_TO_SELL'
export const BET_STATUS_ALL = 'BET_STATUS_ALL'
export const BET_STATUS_SETTLED = 'BET_STATUS_SETTLED'

const {
  UNSETTLED,
  LOSE,
  WIN,
  VOID,
  CASH_OUT,
  CANCELLED,
  PENDING_APPROVAL,
  PENDING_ACCEPT,
  REJECTED,
  FAILED
} = BET_STATUSES

export const betStatusesList = [
  WIN,
  UNSETTLED,
  VOID,
  LOSE,
  CANCELLED,
  CASH_OUT
]

export const extendedBetStatuses = [
  BET_STATUS_ALL,
  BET_STATUS_TO_SELL,
  ...betStatusesList
]

export const compositeBetStatuses = {
  [BET_STATUS_ALL]: [UNSETTLED, LOSE, WIN, VOID, CASH_OUT, PENDING_APPROVAL, PENDING_ACCEPT, REJECTED],
  [BET_STATUS_TO_SELL]: [UNSETTLED, PENDING_APPROVAL],
  [BET_STATUS_SETTLED]: [LOSE, WIN, VOID, CASH_OUT]
}

// actions
export const UPDATE_STATE = 'UPDATE_STATE'
export const SET_BETS = 'SET_BETS'
export const SET_BETS_BY_REQUEST_TIME = 'SET_BETS_BY_REQUEST_TIME'
export const SET_ORDER_CASHOUT_BETS = 'SET_ORDER_CASHOUT_BETS'
export const SET_BET = 'SET_BET'
